import React from 'react';
import { useParams } from "react-router-dom";

/* ----------  generic wrapper  ---------- */
const withRouter = Wrapped => props => {
  const params = useParams();      // { shiftId: "abc123" } or {}
  return <Wrapped {...props} params={params} />;
};

export default withRouter;